const EDITOR_VERSION = "12.0.0";

export default EDITOR_VERSION;
